//lib

//redux
import { useSelector } from "react-redux";

//component
import Col from "../../../components/element/col";
import Row from "../../../components/element/row";
import Image from "../../../components/element/image";
import { Logo, Sample } from "../../../assets/images";
import Button from "../../../components/element/button";
import ArrowButton from "../../../components/common/common.arrow.button";
import Container from "../../../components/element/container";
import Icon from "../../../components/element/icon";
import Radio from "../../../components/element/radio";
import Checkbox from "../../../components/element/checkbox";
import Input from "../../../components/element/input";
import { useState } from "react";

export default function ShopFilter({
  stockCount,
  filterPrice,
  filterSearch,
  filterAvailable,
  setFilterPrice,
  handleClearFilter,
  setFilterAvailable,
  className,
}) {
  const { filterList, filteredProducts } = useSelector(
    (state) => state.product
  );
  const [expandFilter, setExpandFilter] = useState([]);

  const handleExpandFilter = (index) => {
    setExpandFilter((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };

  const handleFilterAvailable = (type) => {
    setFilterAvailable((prevFilters) => {
      if (prevFilters.includes(type)) {
        return prevFilters.filter((filter) => filter !== type);
      } else {
        return [...prevFilters, type];
      }
    });
  };

  const handleFilterPrice = (key, value) => {
    setFilterPrice((prevPrice) => {
      const newPrice = [...prevPrice];

      if (key === "from") {
        newPrice[0] = { from: value ? parseFloat(value) : "" };
      } else if (key === "to") {
        newPrice[1] = { to: value ? parseFloat(value) : "" };
      }

      return newPrice;
    });
  };

  return (
    <Container className={`shop-filter ${className ?? ""}`} id="shop-filter">
      {/* <Row
        className="flex justify-start w-100"
        // onClick={() => handleExpandFilter(filterIndex)}
      >
        <h6 className="_label filter">Filter</h6>
      </Row> */}
      <Row
        className="h-flex justify-between items-center"
        // onClick={() => handleExpandFilter(filterIndex)}
      >
        {filterPrice?.length > 0 ||
        filterAvailable?.length > 0 ||
        filterSearch ? (
          <Button
            className="_button clear-filter"
            onClick={() => handleClearFilter()}
          >
            Clear Filter
            <Icon icon="charm:cross" className="_svg clear" />
          </Button>
        ) : (
          <h6 className="_label filter">Filter</h6>
        )}
        <p className="_label filter-result">
          {filteredProducts?.length} Results
        </p>
      </Row>
      <Col className="v-flex">
        {filterList.map((filter, filterIndex) => {
          const isExpanded = expandFilter.includes(filterIndex);

          return (
            <Col
              className={`_col filter-item ${isExpanded ? "--expanded" : ""}`}
            >
              <Row
                className="flex justify-between w-100 pointer"
                key={filterIndex}
                onClick={() => handleExpandFilter(filterIndex)}
              >
                <h5 className="_label filter-title">{filter.label}</h5>
                <Icon className="_svg arrow" icon="iconamoon:arrow-down-2" />
              </Row>
              {filter.label === "Availability" && (
                <Col
                  style={{
                    overflow: "hidden",
                    opacity: isExpanded ? 1 : 0,
                    maxHeight: isExpanded ? "1000px" : "0px",
                    transition: "max-height 0.3s ease, opacity 0.3s ease",
                  }}
                  className={`flex flex-col gap-2 px-2 ${
                    isExpanded ? "pt-4" : ""
                  }`}
                >
                  <Checkbox
                    labelValue={`In Stock (${stockCount?.inStock})`}
                    name="checkbox_size"
                    classNameCheckbox="w-100 gap-4"
                    checked={
                      filterAvailable?.length > 0 &&
                      filterAvailable.includes("in_stock")
                    }
                    onChange={() => handleFilterAvailable("in_stock")}
                  />
                  <Checkbox
                    labelValue={`Out of Stock (${stockCount?.outOfStock})`}
                    name="checkbox_size"
                    classNameCheckbox="w-100 gap-4"
                    checked={
                      filterAvailable?.length > 0 &&
                      filterAvailable.includes("out_stock")
                    }
                    onChange={() => handleFilterAvailable("out_stock")}
                  />
                </Col>
              )}
              {filter.label === "Price Range" && (
                <Row
                  style={{
                    overflow: "hidden",
                    opacity: isExpanded ? 1 : 0,
                    maxHeight: isExpanded ? "1000px" : "0px",
                    transition: "max-height 0.3s ease, opacity 0.3s ease",
                  }}
                  className={`flex flex-col gap-2 px-2 ${
                    isExpanded ? "pt-4" : ""
                  }`}
                >
                  <Col className="flex items-center gap-2">
                    <Row className="_input price">
                      <p className="_label price-title">RM</p>
                      <Input
                        type="text"
                        value={
                          filterPrice?.length > 0 ? filterPrice[0].from : ""
                        }
                        onChange={(e) => {
                          let value = e.target.value;

                          value = value.replace(/\D/g, "");

                          if (value.length > 1 && value.startsWith("0")) {
                            value = value.replace(/^0+/, "");
                          }

                          handleFilterPrice("from", value);
                        }}
                      />
                    </Row>
                    <p className="_label price-to">-</p>
                    <Row className="_input price">
                      <p className="_label price-title">RM</p>
                      <Input
                        type="text"
                        value={filterPrice?.length > 1 ? filterPrice[1].to : ""}
                        onChange={(e) => {
                          let value = e.target.value;

                          value = value.replace(/\D/g, "");

                          if (value.length > 1 && value.startsWith("0")) {
                            value = value.replace(/^0+/, "");
                          }

                          handleFilterPrice("to", value);
                        }}
                      />
                    </Row>
                  </Col>
                </Row>
              )}
            </Col>
          );
        })}
      </Col>
    </Container>
  );
}
